/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Plan_InstructionsInputs */

const fr_group_plan_instructions = /** @type {((inputs: Group_Plan_InstructionsInputs) => LocalizedString) & { parts: (inputs: Group_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Group_Plan_InstructionsInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Sélectionner plusieurs pièces:  + sélectionner une zone`)
		}),
		{
			parts: /** @type {(inputs: Group_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Sélectionner plusieurs pièces: " }, { type: "markup-start", name: "i", options: {}, attributes: {} }, { type: "markup-end", name: "i", options: {}, attributes: {} }, { type: "text", value: " + sélectionner une zone" }])
			})
		}
	)
);

const en_group_plan_instructions = /** @type {((inputs: Group_Plan_InstructionsInputs) => LocalizedString) & { parts: (inputs: Group_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Group_Plan_InstructionsInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Select several rooms:  + select an area`)
		}),
		{
			parts: /** @type {(inputs: Group_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Select several rooms: " }, { type: "markup-start", name: "i", options: {}, attributes: {} }, { type: "markup-end", name: "i", options: {}, attributes: {} }, { type: "text", value: " + select an area" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Select several rooms: + select an area" |
*
* @param {Group_Plan_InstructionsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const group_plan_instructions = /** @type {((inputs?: Group_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs?: Group_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Group_Plan_InstructionsInputs, { locale?: "fr" | "en" }, { i: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Group_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_group_plan_instructions(inputs)
			return fr_group_plan_instructions(inputs)
		}),
		{
			parts: /** @type {(inputs?: Group_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Group_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (en_group_plan_instructions).parts?.(inputs) ?? [{ type: "text", value: en_group_plan_instructions(inputs) }]
				return /** @type {{ parts?: (inputs: Group_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (fr_group_plan_instructions).parts?.(inputs) ?? [{ type: "text", value: fr_group_plan_instructions(inputs) }]
			})
		}
	)
);